export default __webpack_public_path__ + "static/media/logo_ajou.de91d098.png";